<ng-template cdkPortal>
  @if (
    authService.loggedIn() &&
    (chatStore.conn.activeChannel() || chatStore.data.chats().length > 0 || chatStore.ui.chatWidgetExpanded())
  ) {
    <app-chat-floating-trigger
      (click)="chatStore.ui.toggleWidget()"
      [unreadCount]="unreadMessageCount()"
      [hidden]="chatStore.ui.chatWidgetExpanded()"
    />
    <app-chat-window (dismissed)="chatStore.ui.closeWidget()" [hidden]="!chatStore.ui.chatWidgetExpanded()" />
  }
</ng-template>
